{
  "tools_blocked_hint": "Keine Freigabe für den Besitzer. Das Werkzeug wird im Lauf nicht angeboten.",
  "title": "Agenten",
  "list_title": "Agents",
  "no_agents": "Noch kein Agent",
  "select_or_new": "Wähle rechts einen Agent oder lege einen neuen an.",
  "type": {
    "master": "Master",
    "project": "Projekt",
    "specialist": "Spezialist"
  },
  "fields": {
    "type": "Typ",
    "model": "Modell",
    "temperature": "Temperatur",
    "max_tokens": "Max Tokens",
    "max_tokens_thinking_warning": "⚠ Bei aktivem Thinking kann max_tokens < 8000 zu \"max_tokens erreicht\"-Abbrüchen führen. Empfohlen: ≥ 16384.",
    "description": "Beschreibung",
    "tools": "Tools",
    "tools_count": "Tools ({{selected}}/{{total}})",
    "mcp_servers": "MCP-Server",
    "mcp_count": "MCP-Server ({{selected}}/{{total}})",
    "system_prompt": "System-Prompt",
    "model_not_in_config": "{{model}} (nicht in LLM-Config)",
    "fallback_models": "Fallback-Modelle",
    "fallback_hint": "Bei Quota/Overload/Auth-Fehler des primären Modells werden diese der Reihe nach probiert. Mit ↑ kann die Reihenfolge geändert werden.",
    "domain": "Domäne",
    "domain_placeholder": "z.B. Datenbank, Security, Infrastruktur",
    "thinking_budget": "Extended Thinking Budget: {{tokens}} Tokens",
    "thinking_hint": "Nur bei Anthropic Extended-Thinking-Modellen relevant. 0 = aus.",
    "require_tool_confirm": "Tool-Bestätigung vor Ausführung",
    "require_tool_confirm_hint": "Wenn aktiv: vor jedem Tool-Call erscheint im Chat ein Banner mit Erlauben/Verweigern. Auto-Deny nach 5 Minuten.",
    "max_iterations": "Max Iterationen: {{count}}",
    "max_iterations_hint": "Maximale Tool-Schleifen pro Lauf (Standard: 16, Maximum: 250).",
    "handoff_timeout": "Spezialisten-Timeout (Sekunden)",
    "handoff_timeout_hint": "Maximale Laufzeit eines delegierten Auftrags (30–3600 Sekunden)."
  },
  "info": {
    "title": "Info",
    "id": "ID",
    "owner": "Owner",
    "created_by": "Erstellt von",
    "created_at": "Erstellt am",
    "workspace": "Workspace",
    "project": "Projekt-ID"
  },
  "unsaved_hint": "Du hast ungespeicherte Änderungen.",
  "tabs": {
    "overview": "Übersicht",
    "model": "Modell",
    "tools": "Tools & MCP",
    "mail": "Postfach",
    "skills": "Skills",
    "soul": "Soul",
    "advanced": "Erweitert"
  },
  "mail": {
    "intro": "Eigenes Postfach für diesen Buddy. Alles leer = die globalen Mail-Settings (System → Einstellungen → Mail) werden genutzt. Gefüllt = dieser Buddy sendet/liest über sein eigenes Konto.",
    "smtp_title": "SMTP (Senden)",
    "imap_title": "IMAP (Empfangen)",
    "host": "Host",
    "port": "Port",
    "user": "Benutzer",
    "password": "Passwort",
    "from": "Absender (From)",
    "starttls": "STARTTLS",
    "tls_hint": "Port 465 nutzt automatisch implizites SSL. STARTTLS gilt für 587.",
    "password_placeholder": "Passwort eingeben",
    "password_keep": "•••••••• (gesetzt — leer lassen = behalten)",
    "imap_host_ph": "leer = wie SMTP-Host",
    "imap_login_ph": "leer = wie SMTP-Login",
    "global_suffix": " (global)"
  },
  "soul": {
    "description": "Identität, Verhalten und Hintergrund des Agents als Markdown-Dateien.",
    "replaces_prompt_hint": "Sobald hier ein Feld gefüllt ist, ersetzt die Soul den System-Prompt komplett.",
    "prompt_inactive": "Soul aktiv — dieser System-Prompt wird nicht verwendet. Der Agent nutzt die Soul-Dateien (Reiter „Soul“). Leere dort alle Felder, damit dieser Prompt wieder gilt.",
    "load_template": "Template laden",
    "save_component": "Speichern",
    "saved": "Gespeichert",
    "loading": "Lade Soul...",
    "empty_hint": "Leer lassen = nicht aktiv",
    "identity": "Identität",
    "identity_hint": "Wer bin ich? Name, Charakter, Vibe.",
    "behavior": "Verhalten",
    "behavior_hint": "Wie arbeite ich? Prinzipien, Grenzen.",
    "background": "Hintergrund",
    "background_hint": "Optional: Kontext, Spezialwissen."
  },
  "tool_categories": {
    "all": "Alle ({{count}})",
    "files": "Dateien",
    "shell": "Shell",
    "memory": "Speicher",
    "web": "Web",
    "tasks": "Aufgaben",
    "mail": "Mail",
    "discord": "Discord",
    "agents": "Agenten",
    "other": "Sonstige",
    "plugin": "Plugin: {{name}}"
  },
  "errors": {
    "save_failed": "Speichern fehlgeschlagen",
    "delete_confirm": "Agent \"{{name}}\" wirklich löschen? Inkl. Memory + Workspace.",
    "no_servers_yet": "Noch keine MCP-Server angelegt — siehe MCP-Tab."
  },
  "new_dialog": {
    "title": "Neuen Agent anlegen",
    "type_label": "Typ",
    "model_label": "Modell",
    "no_model": "(kein Modell)",
    "name_label": "Name",
    "name_placeholder": "z.B. Research-Bot",
    "defaults_hint": "Default-Tools für {{type}}: {{count}}",
    "template_label": "Vorlage (optional)",
    "template_none": "— Ohne Vorlage —",
    "template_hint": "Vorlage vorausgewählt: {{count}} Tools, System-Prompt übernommen"
  },
  "compaction": {
    "section_title": "Compaction",
    "section_hint": "Wann und wie der Verlauf zusammengefasst wird",
    "model": "Compact-Modell",
    "model_main": "Wie Hauptmodell ({{model}})",
    "tool_result_limit": "Tool-Result-Limit (Zeichen)",
    "aggressive": "aggressiv",
    "default": "Standard",
    "reserve_tokens": "Reserve-Tokens",
    "threshold_pct": "Trigger bei {{pct}}% des Context-Windows",
    "help": "Bei riesen Sessions hilft ein billigeres Compact-Modell (z.B. claude-haiku) und ein niedrigeres Tool-Result-Limit (500). Threshold < 100% triggert frühzeitig — schützt vor Context-Window-Crashes.",
    "live_truncation": "Live-Truncation (Zeichen)",
    "live_truncation_disabled": "Kein Limit",
    "live_truncation_help": "Kürzt einzelne Tool-Results live auf X Zeichen bevor sie in den LLM-Context gehen. 0 = kein Limit. Empfohlen: 12000.",
    "cache_ttl": "Prompt-Cache TTL",
    "cache_ttl_help": "Wie lange Anthropic den System-Prompt cached. 1h = Cache gilt über mehrere Sessions (2× Write-Kosten). 5m = Anthropic-Default (günstigere Writes, aber Cache verfällt schneller).",
    "max_turns": "Max-Nachrichten (Turn-Netz)",
    "max_turns_auto": "auto",
    "max_turns_help": "Compaction feuert auch, wenn die Nachrichten-Anzahl diesen Wert erreicht — unabhängig von den Tokens. Leer = automatisch (skaliert mit dem Context-Window, z.B. 5000 bei 1M). Nur setzen, wenn ein tool-lastiger Agent zu früh kompaktiert.",
    "reserve_help": "Wirkt nur, wenn größer als die aus dem Trigger-% abgeleitete Headroom. Bei Trigger < 100% gewinnt meist das Prozent (z.B. 75% von 1M = 250k Reserve → dieser Wert bleibt dann wirkungslos)."
  },
  "model_picker": {
    "search": "Modell suchen…",
    "all_providers": "Alle Anbieter",
    "only_free": "nur gratis",
    "count": "{{shown}} von {{total}} Modellen",
    "current": "(aktuell)",
    "none": "Kein Modell passt zum Filter."
  }
}
